<template>
  <div class="product-details" @scroll="handleScroll" ref="scrollContainer">
    <h4 class="main-header" ref="mainHeader"><span class="breadcrumb-link" @click="goTo('products')">{{ $t('products') }}</span> {{`> ${selectedProduct.name}`}} </h4>
    <div class="product-details-column">
      <div
        class="product-details-navigation"
        :class="{ 'sticky': isSticky }"
        ref="navigation"
      >
        <router-view name="navigation"></router-view>
      </div>
      <div class="product-content" v-if="loaded" ref="productContent">
        <router-multi-view view-name="tab"></router-multi-view>
      </div>
    </div>
    <!-- <div class="flex-nowrap content-row" :class="{ 'd-flex': !$vuetify.breakpoint.smAndDown }">
      <product-details-navigation v-if="selectedProduct" :selected="currentTab" class="sidebar ml-2 mr-5"></product-details-navigation>
      <component v-if="loaded" :is="productDetailsMain" :ref="currentTab" class="flex-shrink-1 content flex-grow-1" :class="{ 'is-mobile': $vuetify.breakpoint.smAndDown }"></component>
    </div> -->
    <!-- <div class="floating-bar" v-if="loaded">
      <div class="floating-bar-content" v-show="hasUnsavedChanges || ((currentTab === 'gs1' && isGs1FormLocked) || currentTab === 'qr')">
        <v-btn class="mr-2" v-if="currentTab === 'gs1' && isUpgradingToGs1" @click="triggerCancel()" small text outlined dense color="primary">
          {{$t('cancel')}}
        </v-btn>

        <v-btn class="mr-2" v-if="currentTab === 'gs1' && isGs1FormLocked && isGS1Code" @click="triggerUnlock()" small text outlined dense color="#F22A42">
          <v-icon small class="mr-2">mdi-lock-open-outline</v-icon>
          {{$t('unlock')}}
        </v-btn>

        <v-btn class="mr-2" v-if="currentTab === 'qr'" @click="triggerDownload()" :disabled="downloading" small text outlined dense color="primary">
          <v-icon small class="mr-2">mdi-download</v-icon>
          {{$t('download')}}
        </v-btn>

        <v-btn @click="triggerSave()" v-show="hasUnsavedChanges" :disabled="saving" small dense color="primary">
          {{$t('save')}}
        </v-btn>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Utils from '@/utils/utils'

export default {
  name: 'ProductDetails',
  computed: {
    ...mapGetters(['isGs1FormLocked', 'isUpgradingToGs1', 'selectedProduct', 'hasUnsavedChanges']),

    isGS1Code () {
      return Utils.isGS1Identifier(this.product?.code?.message)
    },

    currentTab () {
      return this.$route.name.split('products.')[1]
    }
  },
  data () {
    return {
      product: null,
      saving: false,
      downloading: false,
      loaded: false,
      isSticky: false,
      headerHeight: 0
    }
  },
  methods: {
    ...mapMutations({
      setSelectedProduct: 'SET_SELECTED_PRODUCT'
    }),

    handleScroll () {
      const scrollContainer = this.$refs.scrollContainer
      const mainHeader = this.$refs.mainHeader

      if (scrollContainer && mainHeader) {
        const scrollTop = scrollContainer.scrollTop
        const headerBottom = mainHeader.offsetHeight // Simplified calculation

        // Make navigation sticky when scrolled past header
        this.isSticky = scrollTop >= headerBottom
      }
    },

    goTo (route) {
      this.$router.push({ name: route })
    },

    async loadProduct (id) {
      this.product = await this.$store.dispatch('loadProduct', id)
      this.product.stc_data = await this.$store.dispatch('loadProductJson', { id })
      console.log('loaded everyting')
    },

    triggerCancel () {
      this.$refs[this.currentTab].cancel()
    },

    triggerUnlock () {
      this.$refs[this.currentTab].openUnlockModalConfirmation()
    },

    async triggerSave () {
      this.saving = true
      await this.$refs[this.currentTab].save()
      this.saving = false
    },

    async triggerDownload () {
      this.downloading = true
      await this.$refs[this.currentTab].download()
      this.downloading = false
    },

    async loadProductCodeCount (id) {
      this.product.code = await this.$store.dispatch('loadProductCodeCount', { product: id })
    }
  },
  async created () {
    if (this.$route.params.product && this.$route.params.product.stc_data) {
      this.product = this.$route.params.product
    } else {
      await this.loadProduct(this.$route.params.id)
    }
    if (!this.product.code) {
      await this.loadProductCodeCount(this.$route.params.id)
    }
    this.setSelectedProduct(this.$route.params.id)
    this.loaded = true
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.mainHeader) {
        this.headerHeight = this.$refs.mainHeader.offsetHeight
      }
    })
  }
}
</script>

<style lang="sass" scoped>
@import '@/variables.sass'

.product-details
  height: calc(100vh - var(--banner-height, 0px))
  background: white
  overflow-y: auto
  position: relative

.main-header
  position: relative
  z-index: 1
  flex-shrink: 0

.product-details-column
  display: flex
  flex-direction: column
  min-height: calc(100vh - 60px)

.product-details-navigation
  background-color: #FAFAFA
  z-index: 10
  transition: all 0.3s ease
  flex-shrink: 0

  &.sticky
    position: sticky
    top: 0
    background-color: white
    border-bottom: 1px solid #e0e0e0
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)

.product-content
  flex: 1
  background: white
  min-height: 0
  overflow-y: visible

.content-row
  height: 100%
  background: white

  .content
    background: white
    height: calc(100vh - 134px)
    overflow: auto
    padding-bottom: 60px
    &.is-mobile
      height: calc(100vh - 169px)

  .navigation
    background-color: #FAFAFA
    border-radius: 6px
    margin-bottom: 10px

    .product-name
      font-size: 26px
    .product-sku
      font-size: 14px
      border-radius: 2px
      border: 1px solid #5D5D5D
      color: #5D5D5D

    &.tiny-font
      .product-name
        font-size: 16px
      .product-sku
        font-size: 12px

.floating-bar
  position: fixed
  margin-left: auto
  bottom: 0px
  margin-right: auto
  display: flex
  width: 100%
  justify-content: center
  transition: .3s
  .floating-bar-content
    padding: 10px
    background: #262626
    border-radius: 5px 5px 0px 0px

// Responsive design
@media (max-width: 768px)
  .product-details-navigation
    &.sticky
      position: sticky
      top: 0

</style>
